export default "__VITE_ASSET__CNvIitPk__"